import { NodeType } from 'prosemirror-model'
import { EditorState } from 'prosemirror-state'

/**
 * Checks whether the selection touches any node of the given type(s)
 * @param nodeType a node type or an array of node types
 * @param state the editor state
 */
export function selectionIncludesNodeType(nodeType: NodeType | NodeType[], state: EditorState) {
  let nodeTypes = Array.isArray(nodeType) ? nodeType : [nodeType]

  let foundNodeType = false

  for (let {
    $from: { pos: from },
    $to: { pos: to },
  } of state.selection.ranges) {
    state.doc.nodesBetween(from, to, (node) => {
      if (foundNodeType) return false
      if (nodeTypes.includes(node.type)) {
        foundNodeType = true
      }
      return true
    })
  }

  return foundNodeType
}
